import React, { memo, useCallback, useContext, useState } from 'react'
import { CirclePlusMinor } from '@shopify/polaris-icons'
import { InviteMCModal } from './InviteMCModal'
import { InviteMCViaMessageForm } from './invite-mc-via-message-form/InviteMCViaMessageForm'
import { Button } from 'src/components/shared/Button'
import { ReloadWrapperContext } from 'src/components/wrapper/reload-wrapper/ReloadWrapper.context'

const InviteMCButtonComponent = () => {
  const { reload } = useContext(ReloadWrapperContext)

  const [isInviteViaMessageOpen, setIsInviteViaMessageOpen] = useState(false)

  const handleOpenInviteViaMessage = useCallback(() => {
    setIsInviteViaMessageOpen(true)
  }, [])

  const handleCloseInviteViaMessage = useCallback(() => {
    setIsInviteViaMessageOpen(false)
  }, [])

  return (
    <>
      <Button
        size="small"
        color="dark"
        startIcon={<CirclePlusMinor fill="white" width={20} />}
        onClick={handleOpenInviteViaMessage}
      >
        Invite MC
      </Button>
      <InviteMCModal
        title="Invite master contractor"
        isOpen={isInviteViaMessageOpen}
        onClose={handleCloseInviteViaMessage}
      >
        <InviteMCViaMessageForm onSubmit={reload} onClose={handleCloseInviteViaMessage} />
      </InviteMCModal>
    </>
  )
}

export const InviteMCButton = memo(InviteMCButtonComponent)
